<template>
  <div>
    <Table
      border
      stripe
      :columns="columns"
      :data="data"
      :loading="loading"
    />
    <Page
      v-if="pageVisible && (total > pageSize)"
      :total="total"
      show-sizer
      show-elevator
      :page-size="pageSize"
      :current="current"
      @on-change="handleChange"
      @on-page-size-change="handlePageSizeChange"
      class-name="page"
    />
  </div>
</template>

<script>
export default {
  name: 'tableAndPage',
  props: {
    columns: {
      type: Array,
      default: () => ([])
    },
    api: {
      type: Function,
      default: () => {}
    },
    searchQuery: {
      type: Object,
      default: () => ({})
    },
    pageVisible: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      data: [],
      loading: false,
      total: 0,
      pageSize: 10,
      current: 1
    }
  },
  mounted () {
    this.getPage()
  },
  methods: {
    async getPage () {
      this.loading = true
      try {
        let query = { ...this.searchQuery }
        if (this.pageVisible) {
          query.PageIndex = this.current
          query.PageSize = this.pageSize
        }
        const { data: { list, total } } = await this.api(query)
        this.data = list || []
        this.total = total
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    handleChange (index) {
      this.current = index
      this.getPage()
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.getPage()
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  margin-top: 16px;
}
</style>